import React from 'react';

type ProjectPlanReadOnlyCardProps = {
  label: string;
  children: React.ReactNode;
};

export const ProjectPlanReadOnlyCard = ({ label, children }: ProjectPlanReadOnlyCardProps) => (
  <div className='flex flex-col gap-1'>
    <span className="text-xs font-medium leading-[18px] text-gray-400">{label}</span>
    <div className='rounded-lg border border-gray-100 bg-gray-50 px-4 py-4'>
      <div className="text-sm font-normal leading-5 text-gray-700">{children}</div>
    </div>
  </div>
);
